<template>
  <div class="report">
    <form action="" class="report__form" @submit.prevent="submit">
      <div class="report-success" v-show="isSuccess == true">
        <div class="report-success__icon">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="#00bd2f" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-check"><polyline points="20 6 9 17 4 12"></polyline></svg>
        </div>
        <div class="report-success__title">Message sent</div>
        <div class="report-success__text">Thank you</div>
      </div>
      <div class="report__row">
        <div class="report__error" v-show="error.select == true">Please choose subject</div>
        <div class="report-select" v-click-outside="hideSelect">
          <span class="report-select__title report__field" @click="toggleSelect">{{subject}} <i class="i i-arrow i-down"></i></span>
          <div class="report-select__list" v-show="isSelect == true" >
            <a class="report-select__item" v-for="(item, index) in themes" :key="index" @click.prevent="select(index)">{{item}}</a>
          </div>
        </div>
      </div>
      <div class="report__row">
        <input type="email" name="email" v-model="email" class="report__input report__field" placeholder="Email for answer" required>
      </div>
      <div class="report__row">
        <div class="report_error" v-show="error.message == true"></div>
        <textarea class="report__input report__field report__input--textarea" maxlength="1500" v-model="message" name="ticket[message]" @input="input($event)"  required placeholder="Your message"></textarea>
        <span class="report__count">{{messageSize}}</span>
      </div>
      <div class="report__row">
        <div class="report__error" v-show="error.file == true">
          File must be type of JPEG / PNG / GIF and limit is 5Mb
        </div>
        <label class="report-upload " for="fileToUpload">
          <span class="report-upload__title report__field">{{fileName}}</span>
          <input type="file" name="fileToUpload" ref="file" @change="checkFile" size="60" id="fileToUpload" class="report-upload__input">
        </label>
      </div>

      <div class="report__row">
        <div id="recaptcha" class="recaptcha"></div>
      </div>

      <div class="report__row">
        <div class="report__error">{{fail}}</div>
        <button class="report__btn" type="submit" :disabled="isDisabled">
          Send
        </button>
      </div>

      
      <div class="report__em">Contact us by <a href="mailto:cs@tubecorporate.com">cs@tubecorporate.com</a></div>
    </form>
  </div>
</template>

<style lang="scss">
.report {
  display: flex;
  justify-content: center;
  align-self: center;
  color: $color-link;
  width: 100%;
  max-width: 440px;
  &-select {
    &__title {
      cursor: pointer;
    }
    &__list {
      	position: absolute;
        display: flex;
        flex-direction: column;
        z-index: 30;
        right: 0;
        left: 0;
        padding: 10px;
        background: $color-background;
        border: 1px solid $color-background-light;
    }
    &__item:not(:last-child) {
      margin-bottom: 10px;
    }
    .i {
      font-size: 3px;
      margin-left: 8px;
    }
  }
  &__error {
    color: red;
    margin-bottom: 10px
  }
  &__btn {
    height: 50px;
    width: 160px;
    display: inline-flex;
    color: #FFF;
    border: 0;
    background: $color-background-overlay;
    justify-content: center;
    align-items: center;
    font-weight: 600;
    font-size: 14px;
    line-height: 20px;
    &:hover {
      background: $color-background-light;
    }
    &[disabled]{
      opacity: 0.7;
      cursor: not-allowed;
      &:hover {
        box-shadow: none;
      }
    }
  }
  &__form {
    width: 100%;
    padding: 20px;
    position: relative;
  }
  &__row {
    position: relative;
  }
  &__row:not(:last-child) {
    margin-bottom: 10px;
  }
  &__count {
    position: absolute;
    bottom: 10px;
    right: 12px;
    font-size: 12px;
  }
  &__field {
    position: relative;
    height: 40px;
    line-height: 20px;
    width: 100%;
    display: inline-flex;
    align-items: center;
    padding-left: 10px;
    padding-right: 10px;
    background: $color-background;
    border: 1px solid $color-border;
  }
  &__input {
    font-size: 14px;
    &--textarea {
      padding-top: 4px;
      padding-bottom: 4px;
      height: auto;
      resize: none;
      overflow: hidden;
      padding-bottom: 25px;
    }
  }
  &-upload {
    position: relative;
    &__title {
      position: relative;
      z-index: 20;
      cursor: pointer;
    }
    &__input {
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      z-index: 1;
    }
  }
  &-success {
    position: absolute;
    top: 0;
    right: 0;
    left: 0;
    bottom: 0;
    z-index: 100;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    background: $color-background;
    &__icon {
      width: 80px;
      height: 80px;
    }
    &__text {
      margin-top: 5px;
      color: $color-link;
    }
    
  }
}

.grecaptcha-badge {
  display: none!important;
}
</style>

<script>


const messageLimit = 1500;

import ClickOutside from 'vue-click-outside'
import remanager from './../helpers/remanager'
import axios from 'axios'

const theme = 'dark'

window.remanager = new remanager({
  key: '6LeQd7cUAAAAAMvFYhyeNMytDpFLrKv5lpHW04u4',
  key3: '6Ldyd7cUAAAAAKrQiPRvsArENgfiKPiUWqWDFbGP',
  theme: theme
});

export default {
  props: {
    
  },
  data: () => ({
    isSuccess: false,
    isDisabled: false,
    isSelect: false,
    subject: 'Subject',
    message: '',
    selectError: false,
    captchaResponse: '',
    file: '',
    fileName: 'Chosen a file (optional)',
    fail: '',
    themes: [
      'DMCA / Copyright Infringement',
      'Technical problems',
      'Inappropriate content',
      'Support request'
    ],
    error: {
      file: false,
      select: false,
      message: false,
    }
  }),
  methods: {
    input(event) {
            event.target.style.height = 'auto';
            event.target.style.height = event.target.scrollHeight + 'px';
    },
    toggleSelect() {
      this.isSelect = !this.isSelect;
    },
    select(index) {
      this.subject = this.themes[index];
      this.isSelect = false;
    },
    hideSelect() {
      this.isSelect = false;
    },
    checkFile() {

      this.error.file = false;

      const availableFormats = ['gif','png', 'jpg', 'jpeg'];
      let fileName = this.$root.$cjer.getExtension(this.$refs.file.files[0].name);

      if( availableFormats.indexOf(fileName) == -1 ) {
        this.error.file = true;
        return;
      }

      if(this.$refs.file.files[0].size > 5000000) {
        this.error.file = true;
        return;
      }

      this.fileName = this.$refs.file.files[0].name;

      
      
      
      return;
    },
    submit() {
      let that = this;

      this.error.select = false;
      if(this.subject == 'Subject') {
        this.error.select = true;
      }
      let config = {
        headers:{'Content-Type': 'multipart/form-data'}
      };
      let fd = new FormData();

      this.captchaResponse = window.remanager.version == 3 ? window.remanager.response3 : this.$el.querySelector('[name="g-recaptcha-response"]').value;
      
      
      fd.append('ticket[custom_field_values][site_type]', 'CJ');
      fd.append('ticket[subject]', this.subject);
      fd.append('email', this.email);
      fd.append('ticket[message]:', this.message);
      fd.append('captcha-v', window.remanager.version);
      fd.append('g-recaptcha-response', this.captchaResponse);
      fd.append('fileToUpload', this.$refs.file.files[0]);


      axios.post(`/app/report.php?ref=${location.href}`, fd, config)
      .then(function (response) {
        let data = response.data;
        

        if(typeof data.reports_count != 'undefined') {
          that.fail = data.reports_count;
          that.isDisabled = true;
          return;
        }

        if(data.recaptcha == 'low score') {
          window.remanager.render();
          return;
        }

        if(typeof data.send != 'undefined') {
          that.isSuccess = true;
        }
        
      })
      .catch(function (error) {
        console.log(error);
      });

    }

  },
  created() {
    setTimeout(() => {
      //window.remanager.render();
      window.remanager.render3();
    }, 2000);

    const that = this;

    return;
    grecaptcha.ready(function() {
    grecaptcha.execute('6Ldyd7cUAAAAAKrQiPRvsArENgfiKPiUWqWDFbGP', {action: 'homepage'}).then(function(token) {
          that.captchaResponse = token;
        });
    });
  },
  computed: {
    messageSize: function() {
      return messageLimit - this.message.length;
    }
  },
  directives: {
    ClickOutside
  }
}
</script>
